!(function(e) {
  if ("object" == typeof exports && "undefined" != typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) define([], e);
  else {
    var t;
    (
      (t =
        "undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
          ? self
          : this).braintree || (t.braintree = {})
    ).paypal = e();
  }
})(function() {
  return (function i(s, a, c) {
    function u(t, e) {
      if (!a[t]) {
        if (!s[t]) {
          var n = "function" == typeof require && require;
          if (!e && n) return n(t, !0);
          if (l) return l(t, !0);
          var r = new Error("Cannot find module '" + t + "'");
          throw ((r.code = "MODULE_NOT_FOUND"), r);
        }
        var o = (a[t] = { exports: {} });
        s[t][0].call(
          o.exports,
          function(e) {
            return u(s[t][1][e] || e);
          },
          o,
          o.exports,
          i,
          s,
          a,
          c
        );
      }
      return a[t].exports;
    }
    for (
      var l = "function" == typeof require && require, e = 0;
      e < c.length;
      e++
    )
      u(c[e]);
    return u;
  })(
    {
      1: [
        function(n, r, e) {
          (function(e) {
            "use strict";
            var t = n("promise-polyfill");
            r.exports = e.Promise || t;
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "promise-polyfill": 23 }
      ],
      2: [
        function(e, t, n) {
          "use strict";
          var s = e("./lib/promise"),
            a = {};
          function r(n) {
            var t,
              r,
              o,
              e,
              i = JSON.stringify(n);
            return !n.forceScriptReload && (e = a[i])
              ? e
              : ((o = document.createElement("script")),
                (t = n.dataAttributes || {}),
                (r = n.container || document.head),
                (o.src = n.src),
                (o.id = n.id),
                (o.async = !0),
                n.crossorigin && o.setAttribute("crossorigin", n.crossorigin),
                Object.keys(t).forEach(function(e) {
                  o.setAttribute("data-" + e, t[e]);
                }),
                (e = new s(function(e, t) {
                  o.addEventListener("load", function() {
                    e(o);
                  }),
                    o.addEventListener("error", function() {
                      t(new Error(n.src + " failed to load."));
                    }),
                    o.addEventListener("abort", function() {
                      t(new Error(n.src + " has aborted."));
                    }),
                    r.appendChild(o);
                })),
                (a[i] = e));
          }
          (r.clearCache = function() {
            a = {};
          }),
            (t.exports = r);
        },
        { "./lib/promise": 1 }
      ],
      3: [
        function(e, n, t) {
          (function(t) {
            "use strict";
            n.exports = function(e) {
              return (e = e || t.navigator.userAgent), /Android/.test(e);
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      4: [
        function(e, t, n) {
          "use strict";
          var r = e("./is-edge"),
            o = e("./is-samsung");
          t.exports = function(e) {
            return !(
              (-1 === (e = e || navigator.userAgent).indexOf("Chrome") &&
                -1 === e.indexOf("CriOS")) ||
              r(e) ||
              o(e)
            );
          };
        },
        { "./is-edge": 5, "./is-samsung": 12 }
      ],
      5: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e) {
            return -1 !== (e = e || navigator.userAgent).indexOf("Edge/");
          };
        },
        {}
      ],
      6: [
        function(e, r, t) {
          (function(t) {
            "use strict";
            var n = e("./is-ie11");
            r.exports = function(e) {
              return (
                -1 !== (e = e || t.navigator.userAgent).indexOf("MSIE") || n(e)
              );
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "./is-ie11": 7 }
      ],
      7: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e) {
            return -1 !== (e = e || navigator.userAgent).indexOf("Trident/7");
          };
        },
        {}
      ],
      8: [
        function(e, n, t) {
          (function(t) {
            "use strict";
            n.exports = function(e) {
              return (e = e || t.navigator.userAgent), /FxiOS/i.test(e);
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      9: [
        function(e, r, t) {
          (function(t) {
            "use strict";
            var n = e("./is-ios");
            r.exports = function(e) {
              return (
                (e = e || t.navigator.userAgent),
                !!n(e) &&
                  (!!(function(e) {
                    return /\bGSA\b/.test(e);
                  })(e) ||
                    /.+AppleWebKit(?!.*Safari)/.test(e))
              );
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "./is-ios": 11 }
      ],
      10: [
        function(e, t, n) {
          (function(n) {
            "use strict";
            var r = e("./is-ios-webview");
            t.exports = function(e, t) {
              return (t = void 0 !== t ? t : n.statusbar.visible), r(e) && t;
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "./is-ios-webview": 9 }
      ],
      11: [
        function(e, n, t) {
          (function(t) {
            "use strict";
            n.exports = function(e) {
              return (
                (e = e || t.navigator.userAgent), /iPhone|iPod|iPad/i.test(e)
              );
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      12: [
        function(e, n, t) {
          (function(t) {
            "use strict";
            n.exports = function(e) {
              return (
                (e = e || t.navigator.userAgent), /SamsungBrowser/i.test(e)
              );
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      13: [
        function(e, c, t) {
          (function(n) {
            "use strict";
            var t = e("./is-android"),
              r = e("./is-ios-firefox"),
              o = e("./is-ios-webview"),
              i = e("./is-chrome"),
              s = e("./is-samsung");
            function a(e) {
              return (
                -1 < (e = e || n.navigator.userAgent).indexOf("Opera Mini")
              );
            }
            c.exports = function(e) {
              return (
                (e = e || n.navigator.userAgent),
                !(
                  o(e) ||
                  r(e) ||
                  (function(e) {
                    return (
                      (e = e || n.navigator.userAgent),
                      !!t(e) && /Version\/[\d\.]+/.test(e) && !a(e)
                    );
                  })(e) ||
                  a(e) ||
                  (function(e) {
                    var t;
                    return (
                      !!(t = (e = e || n.navigator.userAgent).match(
                        /CriOS\/(\d+)\./
                      )) && parseInt(t[1], 10) < 48
                    );
                  })(e) ||
                  (function(e) {
                    return !i(e) && !s(e) && /samsung/i.test(e);
                  })(e)
                )
              );
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {
          "./is-android": 3,
          "./is-chrome": 4,
          "./is-ios-firefox": 8,
          "./is-ios-webview": 9,
          "./is-samsung": 12
        }
      ],
      14: [
        function(e, t, n) {
          "use strict";
          var r = e("./lib/set-attributes"),
            o = e("./lib/default-attributes"),
            i = e("./lib/assign");
          t.exports = function(e) {
            var t = document.createElement("iframe"),
              n = i({}, o, e);
            return (
              n.style &&
                "string" != typeof n.style &&
                (i(t.style, n.style), delete n.style),
              r(t, n),
              t.getAttribute("id") || (t.id = t.name),
              t
            );
          };
        },
        {
          "./lib/assign": 15,
          "./lib/default-attributes": 16,
          "./lib/set-attributes": 17
        }
      ],
      15: [
        function(e, t, n) {
          "use strict";
          t.exports = function(n) {
            return (
              Array.prototype.slice.call(arguments, 1).forEach(function(t) {
                "object" == typeof t &&
                  Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                  });
              }),
              n
            );
          };
        },
        {}
      ],
      16: [
        function(e, t, n) {
          "use strict";
          t.exports = {
            src: "about:blank",
            frameBorder: 0,
            allowtransparency: !0,
            scrolling: "no"
          };
        },
        {}
      ],
      17: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e, t) {
            var n;
            for (var r in t)
              t.hasOwnProperty(r) &&
                (null == (n = t[r])
                  ? e.removeAttribute(r)
                  : e.setAttribute(r, n));
          };
        },
        {}
      ],
      18: [
        function(e, t, n) {
          "use strict";
          t.exports = function(t) {
            return function() {
              var e = arguments;
              setTimeout(function() {
                try {
                  t.apply(null, e);
                } catch (e) {
                  console.log("Error in callback function"), console.log(e);
                }
              }, 1);
            };
          };
        },
        {}
      ],
      19: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e) {
            var t = !1;
            return function() {
              t || ((t = !0), e.apply(null, arguments));
            };
          };
        },
        {}
      ],
      20: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e, t) {
            if (!t) return e;
            e.then(function(e) {
              t(null, e);
            }).catch(function(e) {
              t(e);
            });
          };
        },
        {}
      ],
      21: [
        function(e, t, n) {
          "use strict";
          var r = e("./lib/deferred"),
            o = e("./lib/once"),
            i = e("./lib/promise-or-callback");
          function a(n) {
            return function() {
              var e,
                t = Array.prototype.slice.call(arguments);
              return (
                "function" == typeof t[t.length - 1] &&
                  ((e = t.pop()), (e = o(r(e)))),
                i(n.apply(this, t), e)
              );
            };
          }
          (a.wrapPrototype = function(o, e) {
            var i, s;
            return (
              (i = (e = e || {}).ignoreMethods || []),
              (s = !0 === e.transformPrivateMethods),
              Object.getOwnPropertyNames(o.prototype)
                .filter(function(e) {
                  var t,
                    n =
                      "constructor" !== e &&
                      "function" == typeof o.prototype[e],
                    r = -1 === i.indexOf(e);
                  return (t = s || "_" !== e.charAt(0)), n && t && r;
                })
                .forEach(function(e) {
                  var t = o.prototype[e];
                  o.prototype[e] = a(t);
                }),
              o
            );
          }),
            (t.exports = a);
        },
        {
          "./lib/deferred": 18,
          "./lib/once": 19,
          "./lib/promise-or-callback": 20
        }
      ],
      22: [
        function(e, b, t) {
          (function(t) {
            "use strict";
            var r,
              s,
              i = [],
              a = {},
              c = "/*framebus*/";
            function e(e) {
              var t,
                n = u(this);
              return (
                !l(e) &&
                !l(n) &&
                !1 !==
                  (t = p(e, Array.prototype.slice.call(arguments, 1), n)) &&
                (m(r.top || r.self, t, n), !0)
              );
            }
            function n(e, t) {
              var n = u(this);
              return (
                !g(e, t, n) &&
                ((a[n] = a[n] || {}),
                (a[n][e] = a[n][e] || []),
                a[n][e].push(t),
                !0)
              );
            }
            function o(e, t) {
              var n,
                r,
                o = u(this);
              if (g(e, t, o)) return !1;
              if (!(r = a[o] && a[o][e])) return !1;
              for (n = 0; n < r.length; n++)
                if (r[n] === t) return r.splice(n, 1), !0;
              return !1;
            }
            function u(e) {
              return (e && e._origin) || "*";
            }
            function l(e) {
              return "string" != typeof e;
            }
            function p(e, t, n) {
              var r = !1,
                o = { event: e, origin: n },
                i = t[t.length - 1];
              "function" == typeof i &&
                ((o.reply = E(i, n)), (t = t.slice(0, -1))),
                (o.args = t);
              try {
                r = c + JSON.stringify(o);
              } catch (e) {
                throw new Error("Could not stringify event: " + e.message);
              }
              return r;
            }
            function f(e) {
              var t, n, r, o;
              if (e.data.slice(0, c.length) !== c) return !1;
              try {
                t = JSON.parse(e.data.slice(c.length));
              } catch (e) {
                return !1;
              }
              return (
                null != t.reply &&
                  ((n = e.origin),
                  (r = e.source),
                  (o = t.reply),
                  (t.reply = function(e) {
                    var t;
                    return (
                      !!r &&
                      !1 !== (t = p(o, [e], n)) &&
                      void r.postMessage(t, n)
                    );
                  }),
                  t.args.push(t.reply)),
                t
              );
            }
            function d(e) {
              r ||
                ((r = e || t).addEventListener
                  ? r.addEventListener("message", _, !1)
                  : r.attachEvent
                  ? r.attachEvent("onmessage", _)
                  : null === r.onmessage
                  ? (r.onmessage = _)
                  : (r = null));
            }
            function h() {
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function(e) {
                  var t = (16 * Math.random()) | 0;
                  return ("x" === e ? t : (3 & t) | 8).toString(16);
                }
              );
            }
            function _(e) {
              var t;
              l(e.data) ||
                ((t = f(e)) &&
                  (y("*", t.event, t.args, e),
                  y(e.origin, t.event, t.args, e),
                  (function(e, t, n) {
                    var r, o;
                    for (r = i.length - 1; 0 <= r; r--)
                      !0 === (o = i[r]).closed
                        ? (i = i.slice(r, 1))
                        : n !== o && m(o.top, e, t);
                  })(e.data, t.origin, e.source)));
            }
            function y(e, t, n, r) {
              var o;
              if (a[e] && a[e][t])
                for (o = 0; o < a[e][t].length; o++) a[e][t][o].apply(r, n);
            }
            function m(e, t, n) {
              var r,
                o = 0;
              try {
                for (
                  e.postMessage(t, n),
                    (function(e) {
                      return (
                        e.top === e &&
                        null != e.opener &&
                        e.opener !== e &&
                        !0 !== e.opener.closed
                      );
                    })(e) && m(e.opener.top, t, n);
                  (r = e.frames[o]);

                )
                  m(r, t, n), o++;
              } catch (e) {}
            }
            function E(r, o) {
              var i = h();
              return (
                s.target(o).subscribe(i, function e(t, n) {
                  r(t, n), s.target(o).unsubscribe(i, e);
                }),
                i
              );
            }
            function g(e, t, n) {
              return !!l(e) || "function" != typeof t || !!l(n);
            }
            d(),
              (s = {
                target: function(e) {
                  var t,
                    n = {};
                  for (t in s) s.hasOwnProperty(t) && (n[t] = s[t]);
                  return (n._origin = e || "*"), n;
                },
                _packagePayload: p,
                _unpackPayload: f,
                _attach: d,
                _detach: function() {
                  null != r &&
                    (r.removeEventListener
                      ? r.removeEventListener("message", _, !1)
                      : r.detachEvent
                      ? r.detachEvent("onmessage", _)
                      : r.onmessage === _ && (r.onmessage = null),
                    (r = null),
                    (i = []),
                    (a = {}));
                },
                _dispatch: y,
                _broadcast: m,
                _subscribeReplier: E,
                _subscriptionArgsInvalid: g,
                _onmessage: _,
                _uuid: h,
                _getSubscribers: function() {
                  return a;
                },
                _win: function() {
                  return r;
                },
                include: function(e) {
                  return (
                    null != e &&
                    null != e.Window &&
                    e.constructor === e.Window &&
                    (i.push(e), !0)
                  );
                },
                publish: e,
                pub: e,
                trigger: e,
                emit: e,
                subscribe: n,
                sub: n,
                on: n,
                unsubscribe: o,
                unsub: o,
                off: o
              }),
              (b.exports = s);
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      23: [
        function(e, t, n) {
          "use strict";
          var r = setTimeout;
          function c(e) {
            return Boolean(e && void 0 !== e.length);
          }
          function o() {}
          function i(e) {
            if (!(this instanceof i))
              throw new TypeError("Promises must be constructed via new");
            if ("function" != typeof e) throw new TypeError("not a function");
            (this._state = 0),
              (this._handled = !1),
              (this._value = void 0),
              (this._deferreds = []),
              f(e, this);
          }
          function s(n, r) {
            for (; 3 === n._state; ) n = n._value;
            0 !== n._state
              ? ((n._handled = !0),
                i._immediateFn(function() {
                  var e = 1 === n._state ? r.onFulfilled : r.onRejected;
                  if (null !== e) {
                    var t;
                    try {
                      t = e(n._value);
                    } catch (e) {
                      return void u(r.promise, e);
                    }
                    a(r.promise, t);
                  } else (1 === n._state ? a : u)(r.promise, n._value);
                }))
              : n._deferreds.push(r);
          }
          function a(t, e) {
            try {
              if (e === t)
                throw new TypeError(
                  "A promise cannot be resolved with itself."
                );
              if (e && ("object" == typeof e || "function" == typeof e)) {
                var n = e.then;
                if (e instanceof i)
                  return (t._state = 3), (t._value = e), void l(t);
                if ("function" == typeof n)
                  return void f(
                    (function(e, t) {
                      return function() {
                        e.apply(t, arguments);
                      };
                    })(n, e),
                    t
                  );
              }
              (t._state = 1), (t._value = e), l(t);
            } catch (e) {
              u(t, e);
            }
          }
          function u(e, t) {
            (e._state = 2), (e._value = t), l(e);
          }
          function l(e) {
            2 === e._state &&
              0 === e._deferreds.length &&
              i._immediateFn(function() {
                e._handled || i._unhandledRejectionFn(e._value);
              });
            for (var t = 0, n = e._deferreds.length; t < n; t++)
              s(e, e._deferreds[t]);
            e._deferreds = null;
          }
          function p(e, t, n) {
            (this.onFulfilled = "function" == typeof e ? e : null),
              (this.onRejected = "function" == typeof t ? t : null),
              (this.promise = n);
          }
          function f(e, t) {
            var n = !1;
            try {
              e(
                function(e) {
                  n || ((n = !0), a(t, e));
                },
                function(e) {
                  n || ((n = !0), u(t, e));
                }
              );
            } catch (e) {
              if (n) return;
              (n = !0), u(t, e);
            }
          }
          (i.prototype.catch = function(e) {
            return this.then(null, e);
          }),
            (i.prototype.then = function(e, t) {
              var n = new this.constructor(o);
              return s(this, new p(e, t, n)), n;
            }),
            (i.prototype.finally = function(t) {
              var n = this.constructor;
              return this.then(
                function(e) {
                  return n.resolve(t()).then(function() {
                    return e;
                  });
                },
                function(e) {
                  return n.resolve(t()).then(function() {
                    return n.reject(e);
                  });
                }
              );
            }),
            (i.all = function(t) {
              return new i(function(r, o) {
                if (!c(t))
                  return o(new TypeError("Promise.all accepts an array"));
                var i = Array.prototype.slice.call(t);
                if (0 === i.length) return r([]);
                var s = i.length;
                function a(t, e) {
                  try {
                    if (e && ("object" == typeof e || "function" == typeof e)) {
                      var n = e.then;
                      if ("function" == typeof n)
                        return void n.call(
                          e,
                          function(e) {
                            a(t, e);
                          },
                          o
                        );
                    }
                    (i[t] = e), 0 == --s && r(i);
                  } catch (e) {
                    o(e);
                  }
                }
                for (var e = 0; e < i.length; e++) a(e, i[e]);
              });
            }),
            (i.resolve = function(t) {
              return t && "object" == typeof t && t.constructor === i
                ? t
                : new i(function(e) {
                    e(t);
                  });
            }),
            (i.reject = function(n) {
              return new i(function(e, t) {
                t(n);
              });
            }),
            (i.race = function(o) {
              return new i(function(e, t) {
                if (!c(o))
                  return t(new TypeError("Promise.race accepts an array"));
                for (var n = 0, r = o.length; n < r; n++)
                  i.resolve(o[n]).then(e, t);
              });
            }),
            (i._immediateFn =
              ("function" == typeof setImmediate &&
                function(e) {
                  setImmediate(e);
                }) ||
              function(e) {
                r(e, 0);
              }),
            (i._unhandledRejectionFn = function(e) {
              "undefined" != typeof console &&
                console &&
                console.warn("Possible Unhandled Promise Rejection:", e);
            }),
            (t.exports = i);
        },
        {}
      ],
      24: [
        function(e, t, n) {
          "use strict";
          var s = e("./create-authorization-data"),
            a = e("./json-clone"),
            c = e("./constants");
          t.exports = function(e, t) {
            var n,
              r = t ? a(t) : {},
              o = s(e.authorization).attrs,
              i = a(e.analyticsMetadata);
            for (n in ((r.braintreeLibraryVersion =
              c.BRAINTREE_LIBRARY_VERSION),
            r._meta))
              r._meta.hasOwnProperty(n) && (i[n] = r._meta[n]);
            return (
              (r._meta = i),
              o.tokenizationKey
                ? (r.tokenizationKey = o.tokenizationKey)
                : (r.authorizationFingerprint = o.authorizationFingerprint),
              r
            );
          };
        },
        {
          "./constants": 33,
          "./create-authorization-data": 37,
          "./json-clone": 55
        }
      ],
      25: [
        function(e, t, n) {
          "use strict";
          var r = e("./promise"),
            u = e("./constants"),
            l = e("./add-metadata");
          function p(e) {
            return Math.floor(e / 1e3);
          }
          t.exports = {
            sendEvent: function(e, s, a) {
              var c = p(Date.now());
              return r.resolve(e).then(function(e) {
                var t = p(Date.now()),
                  n = e.getConfiguration(),
                  r = e._request,
                  o = n.gatewayConfiguration.analytics.url,
                  i = {
                    analytics: [
                      {
                        kind: u.ANALYTICS_PREFIX + s,
                        isAsync: t !== c,
                        timestamp: c
                      }
                    ]
                  };
                r(
                  {
                    url: o,
                    method: "post",
                    data: l(n, i),
                    timeout: u.ANALYTICS_REQUEST_TIMEOUT_MS
                  },
                  a
                );
              });
            }
          };
        },
        { "./add-metadata": 24, "./constants": 33, "./promise": 58 }
      ],
      26: [
        function(e, t, n) {
          "use strict";
          var r = e("@braintree/asset-loader/load-script");
          t.exports = { loadScript: r };
        },
        { "@braintree/asset-loader/load-script": 2 }
      ],
      27: [
        function(e, t, n) {
          "use strict";
          var r = "function" == typeof Object.assign ? Object.assign : o;
          function o(e) {
            var t, n, r;
            for (t = 1; t < arguments.length; t++)
              for (r in (n = arguments[t]))
                n.hasOwnProperty(r) && (e[r] = n[r]);
            return e;
          }
          t.exports = { assign: r, _assign: o };
        },
        {}
      ],
      28: [
        function(e, t, n) {
          "use strict";
          var o = e("./braintree-error"),
            i = e("./promise"),
            s = e("./errors");
          t.exports = {
            verify: function(e) {
              var t, n, r;
              return e
                ? ((r = e.name),
                  (t = e.client),
                  (n = e.authorization),
                  null == t && null == n
                    ? i.reject(
                        new o({
                          type: s.INSTANTIATION_OPTION_REQUIRED.type,
                          code: s.INSTANTIATION_OPTION_REQUIRED.code,
                          message:
                            "options.client is required when instantiating " +
                            r +
                            "."
                        })
                      )
                    : n || "3.47.0" === t.getVersion()
                    ? i.resolve()
                    : i.reject(
                        new o({
                          type: s.INCOMPATIBLE_VERSIONS.type,
                          code: s.INCOMPATIBLE_VERSIONS.code,
                          message:
                            "Client (version " +
                            t.getVersion() +
                            ") and " +
                            r +
                            " (version 3.47.0) components must be from the same SDK version."
                        })
                      ))
                : i.reject(
                    new o({
                      type: s.INVALID_USE_OF_INTERNAL_FUNCTION.type,
                      code: s.INVALID_USE_OF_INTERNAL_FUNCTION.code,
                      message:
                        "Options must be passed to basicComponentVerification function."
                    })
                  );
            }
          };
        },
        { "./braintree-error": 29, "./errors": 41, "./promise": 58 }
      ],
      29: [
        function(e, t, n) {
          "use strict";
          var r = e("./enumerate");
          function o(e) {
            if (!o.types.hasOwnProperty(e.type))
              throw new Error(e.type + " is not a valid type.");
            if (!e.code) throw new Error("Error code required.");
            if (!e.message) throw new Error("Error message required.");
            (this.name = "BraintreeError"),
              (this.code = e.code),
              (this.message = e.message),
              (this.type = e.type),
              (this.details = e.details);
          }
          (((o.prototype = Object.create(
            Error.prototype
          )).constructor = o).types = r([
            "CUSTOMER",
            "MERCHANT",
            "NETWORK",
            "INTERNAL",
            "UNKNOWN"
          ])),
            (o.findRootError = function(e) {
              return e instanceof o && e.details && e.details.originalError
                ? o.findRootError(e.details.originalError)
                : e;
            }),
            (t.exports = o);
        },
        { "./enumerate": 40 }
      ],
      30: [
        function(e, t, n) {
          "use strict";
          var o = e("../is-verified-domain");
          t.exports = {
            checkOrigin: function(e, t) {
              var n,
                r = document.createElement("a");
              return (
                (r.href = t),
                (n =
                  "https:" === r.protocol
                    ? r.host.replace(/:443$/, "")
                    : "http:" === r.protocol
                    ? r.host.replace(/:80$/, "")
                    : r.host),
                r.protocol + "//" + n === e || ((r.href = e), o(e))
              );
            }
          };
        },
        { "../is-verified-domain": 54 }
      ],
      31: [
        function(e, t, n) {
          "use strict";
          var r = e("../enumerate");
          t.exports = r(["CONFIGURATION_REQUEST"], "bus:");
        },
        { "../enumerate": 40 }
      ],
      32: [
        function(e, t, n) {
          "use strict";
          var s = e("framebus"),
            r = e("./events"),
            a = e("./check-origin").checkOrigin,
            o = e("../braintree-error");
          function i(e) {
            if (((e = e || {}), (this.channel = e.channel), !this.channel))
              throw new o({
                type: o.types.INTERNAL,
                code: "MISSING_CHANNEL_ID",
                message: "Channel ID must be specified."
              });
            (this.merchantUrl = e.merchantUrl),
              (this._isDestroyed = !1),
              (this._isVerbose = !1),
              (this._listeners = []),
              this._log("new bus on channel " + this.channel, [location.href]);
          }
          (i.prototype.on = function(e, t) {
            var n,
              r,
              o = t,
              i = this;
            this._isDestroyed ||
              (this.merchantUrl &&
                (o = function() {
                  a(this.origin, i.merchantUrl) && t.apply(this, arguments);
                }),
              (n = this._namespaceEvent(e)),
              ((r = Array.prototype.slice.call(arguments))[0] = n),
              (r[1] = o),
              this._log("on", r),
              s.on.apply(s, r),
              this._listeners.push({
                eventName: e,
                handler: o,
                originalHandler: t
              }));
          }),
            (i.prototype.emit = function(e) {
              var t;
              this._isDestroyed ||
                (((t = Array.prototype.slice.call(
                  arguments
                ))[0] = this._namespaceEvent(e)),
                this._log("emit", t),
                s.emit.apply(s, t));
            }),
            (i.prototype._offDirect = function(e) {
              var t = Array.prototype.slice.call(arguments);
              this._isDestroyed ||
                ((t[0] = this._namespaceEvent(e)),
                this._log("off", t),
                s.off.apply(s, t));
            }),
            (i.prototype.off = function(e, t) {
              var n,
                r,
                o = t;
              if (!this._isDestroyed) {
                if (this.merchantUrl)
                  for (n = 0; n < this._listeners.length; n++)
                    (r = this._listeners[n]).originalHandler === t &&
                      (o = r.handler);
                this._offDirect(e, o);
              }
            }),
            (i.prototype._namespaceEvent = function(e) {
              return ["braintree", this.channel, e].join(":");
            }),
            (i.prototype.teardown = function() {
              var e, t;
              for (t = 0; t < this._listeners.length; t++)
                (e = this._listeners[t]),
                  this._offDirect(e.eventName, e.handler);
              (this._listeners.length = 0), (this._isDestroyed = !0);
            }),
            (i.prototype._log = function(e, t) {
              this._isVerbose && console.log(e, t);
            }),
            (i.events = r),
            (t.exports = i);
        },
        {
          "../braintree-error": 29,
          "./check-origin": 30,
          "./events": 31,
          framebus: 22
        }
      ],
      33: [
        function(e, t, n) {
          "use strict";
          t.exports = {
            ANALYTICS_PREFIX: "web.",
            ANALYTICS_REQUEST_TIMEOUT_MS: 2e3,
            ASSETS_URLS: {
              production: "https://assets.braintreegateway.com",
              sandbox: "https://assets.braintreegateway.com"
            },
            CLIENT_API_URLS: {
              production: "https://api.braintreegateway.com:443",
              sandbox: "https://api.sandbox.braintreegateway.com:443"
            },
            FRAUDNET_SOURCE: "BRAINTREE_SIGNIN",
            FRAUDNET_FNCLS: "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99",
            FRAUDNET_URL: "https://c.paypal.com/da/r/fb.js",
            GRAPHQL_URLS: {
              production: "https://payments.braintree-api.com/graphql",
              sandbox: "https://payments.sandbox.braintree-api.com/graphql"
            },
            INTEGRATION_TIMEOUT_MS: 6e4,
            VERSION: "3.47.0",
            INTEGRATION: "custom",
            SOURCE: "client",
            PLATFORM: "web",
            BRAINTREE_LIBRARY_VERSION: "braintree/web/3.47.0"
          };
        },
        {}
      ],
      34: [
        function(e, t, n) {
          "use strict";
          var r = e("./braintree-error"),
            o = e("./errors");
          t.exports = function(t, e) {
            e.forEach(function(e) {
              t[e] = function() {
                throw new r({
                  type: o.METHOD_CALLED_AFTER_TEARDOWN.type,
                  code: o.METHOD_CALLED_AFTER_TEARDOWN.code,
                  message: e + " cannot be called after teardown."
                });
              };
            });
          };
        },
        { "./braintree-error": 29, "./errors": 41 }
      ],
      35: [
        function(e, t, n) {
          "use strict";
          var r = e("./braintree-error");
          t.exports = function(e, t) {
            return e instanceof r
              ? e
              : new r({
                  type: t.type,
                  code: t.code,
                  message: t.message,
                  details: { originalError: e }
                });
          };
        },
        { "./braintree-error": 29 }
      ],
      36: [
        function(e, t, n) {
          "use strict";
          var r = e("./constants").ASSETS_URLS;
          t.exports = {
            create: function(e) {
              return r.production;
            }
          };
        },
        { "./constants": 33 }
      ],
      37: [
        function(e, t, n) {
          "use strict";
          var o = e("../lib/vendor/polyfill").atob,
            i = e("../lib/constants").CLIENT_API_URLS;
          t.exports = function(e) {
            var t,
              n,
              r = { attrs: {}, configUrl: "" };
            return (
              !(function(e) {
                return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(e);
              })(e)
                ? ((t = JSON.parse(o(e))),
                  (r.environment = t.environment),
                  (r.attrs.authorizationFingerprint =
                    t.authorizationFingerprint),
                  (r.configUrl = t.configUrl),
                  (r.graphQL = t.graphQL))
                : ((n = (function(e) {
                    var t = e.split("_"),
                      n = t[0];
                    return { merchantId: t.slice(2).join("_"), environment: n };
                  })(e)),
                  (r.environment = n.environment),
                  (r.attrs.tokenizationKey = e),
                  (r.configUrl =
                    i[n.environment] +
                    "/merchants/" +
                    n.merchantId +
                    "/client_api/v1/configuration")),
              r
            );
          };
        },
        { "../lib/constants": 33, "../lib/vendor/polyfill": 61 }
      ],
      38: [
        function(e, t, n) {
          (function(n) {
            "use strict";
            var r = e("./braintree-error"),
              o = e("./promise"),
              i = e("./assets"),
              s = e("./errors"),
              a = "3.47.0";
            t.exports = {
              create: function(e) {
                var t = o.resolve();
                return e.client
                  ? o.resolve(e.client)
                  : ((n.braintree && n.braintree.client) ||
                      (t = i
                        .loadScript({
                          src: e.assetsUrl + "/web/" + a + "/js/client.min.js"
                        })
                        .catch(function(e) {
                          return o.reject(
                            new r({
                              type: s.CLIENT_SCRIPT_FAILED_TO_LOAD.type,
                              code: s.CLIENT_SCRIPT_FAILED_TO_LOAD.code,
                              message: s.CLIENT_SCRIPT_FAILED_TO_LOAD.message,
                              details: { originalError: e }
                            })
                          );
                        })),
                    t.then(function() {
                      return n.braintree.client.VERSION !== a
                        ? o.reject(
                            new r({
                              type: s.INCOMPATIBLE_VERSIONS.type,
                              code: s.INCOMPATIBLE_VERSIONS.code,
                              message:
                                "Client (version " +
                                n.braintree.client.VERSION +
                                ") and " +
                                e.name +
                                " (version " +
                                a +
                                ") components must be from the same SDK version."
                            })
                          )
                        : n.braintree.client.create({
                            authorization: e.authorization,
                            debug: e.debug
                          });
                    }));
              }
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {
          "./assets": 26,
          "./braintree-error": 29,
          "./errors": 41,
          "./promise": 58
        }
      ],
      39: [
        function(e, t, n) {
          "use strict";
          t.exports = function(t) {
            return function() {
              var e = arguments;
              setTimeout(function() {
                t.apply(null, e);
              }, 1);
            };
          };
        },
        {}
      ],
      40: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e, n) {
            return (
              (n = null == n ? "" : n),
              e.reduce(function(e, t) {
                return (e[t] = n + t), e;
              }, {})
            );
          };
        },
        {}
      ],
      41: [
        function(e, t, n) {
          "use strict";
          var r = e("./braintree-error");
          t.exports = {
            INVALID_USE_OF_INTERNAL_FUNCTION: {
              type: r.types.INTERNAL,
              code: "INVALID_USE_OF_INTERNAL_FUNCTION"
            },
            INSTANTIATION_OPTION_REQUIRED: {
              type: r.types.MERCHANT,
              code: "INSTANTIATION_OPTION_REQUIRED"
            },
            INCOMPATIBLE_VERSIONS: {
              type: r.types.MERCHANT,
              code: "INCOMPATIBLE_VERSIONS"
            },
            CLIENT_SCRIPT_FAILED_TO_LOAD: {
              type: r.types.NETWORK,
              code: "CLIENT_SCRIPT_FAILED_TO_LOAD",
              message: "Braintree client script could not be loaded."
            },
            METHOD_CALLED_AFTER_TEARDOWN: {
              type: r.types.MERCHANT,
              code: "METHOD_CALLED_AFTER_TEARDOWN"
            },
            BRAINTREE_API_ACCESS_RESTRICTED: {
              type: r.types.MERCHANT,
              code: "BRAINTREE_API_ACCESS_RESTRICTED",
              message:
                "Your access is restricted and cannot use this part of the Braintree API."
            }
          };
        },
        { "./braintree-error": 29 }
      ],
      42: [
        function(m, E, e) {
          (function(o) {
            "use strict";
            var i = m("./strategies/popup"),
              s = m("./strategies/popup-bridge"),
              a = m("./strategies/modal"),
              t = m("../../bus"),
              n = m("../shared/events"),
              r = m("../shared/errors"),
              c = m("../shared/constants"),
              u = m("../../vendor/uuid"),
              l = m("@braintree/iframer"),
              p = m("../../braintree-error"),
              f = m("../shared/browser-detection"),
              d = m("../../is-https"),
              h = m("./../../assign").assign,
              _ = ["name", "dispatchFrameUrl", "openFrameUrl"];
            function e() {}
            function y(e) {
              !(function(t) {
                if (!t) throw new Error("Valid configuration is required");
                if (
                  (_.forEach(function(e) {
                    if (!t.hasOwnProperty(e))
                      throw new Error(
                        "A valid frame " + e + " must be provided"
                      );
                  }),
                  !/^[\w_]+$/.test(t.name))
                )
                  throw new Error("A valid frame name must be provided");
              })(e),
                (this._serviceId = u().replace(/-/g, "")),
                (this._options = {
                  name: e.name + "_" + this._serviceId,
                  dispatchFrameUrl: e.dispatchFrameUrl,
                  openFrameUrl: e.openFrameUrl,
                  height: e.height,
                  width: e.width,
                  top: e.top,
                  left: e.left
                }),
                (this.state = e.state || {}),
                (this._bus = new t({ channel: this._serviceId })),
                this._setBusEvents();
            }
            (y.prototype.initialize = function(e) {
              var t = function() {
                e(), this._bus.off(n.DISPATCH_FRAME_READY, t);
              }.bind(this);
              this._bus.on(n.DISPATCH_FRAME_READY, t),
                this._writeDispatchFrame();
            }),
              (y.prototype._writeDispatchFrame = function() {
                var e = c.DISPATCH_FRAME_NAME + "_" + this._serviceId,
                  t = this._options.dispatchFrameUrl;
                (this._dispatchFrame = l({
                  "aria-hidden": !0,
                  name: e,
                  title: e,
                  src: t,
                  class: c.DISPATCH_FRAME_CLASS,
                  height: 0,
                  width: 0,
                  style: { position: "absolute", left: "-9999px" }
                })),
                  document.body.appendChild(this._dispatchFrame);
              }),
              (y.prototype._setBusEvents = function() {
                this._bus.on(
                  n.DISPATCH_FRAME_REPORT,
                  function(e, t) {
                    this._onCompleteCallback &&
                      this._onCompleteCallback.call(null, e.err, e.payload),
                      this._frame.close(),
                      (this._onCompleteCallback = null),
                      t && t();
                  }.bind(this)
                ),
                  this._bus.on(
                    t.events.CONFIGURATION_REQUEST,
                    function(e) {
                      e(this.state);
                    }.bind(this)
                  );
              }),
              (y.prototype.open = function(e, t) {
                if (
                  ((e = e || {}),
                  (this._frame = this._getFrameForEnvironment(e)),
                  this._frame.initialize(t),
                  !(this._frame instanceof s))
                ) {
                  if (
                    (h(this.state, e.state),
                    (this._onCompleteCallback = t),
                    this._frame.open(),
                    this.isFrameClosed())
                  )
                    return (
                      this._cleanupFrame(),
                      void (
                        t &&
                        t(
                          f.isIE() && !d.isHTTPS()
                            ? new p(r.FRAME_SERVICE_FRAME_OPEN_FAILED_IE_BUG)
                            : new p(r.FRAME_SERVICE_FRAME_OPEN_FAILED)
                        )
                      )
                    );
                  this._pollForPopupClose();
                }
              }),
              (y.prototype.redirect = function(e) {
                this._frame && !this.isFrameClosed() && this._frame.redirect(e);
              }),
              (y.prototype.close = function() {
                this.isFrameClosed() || this._frame.close();
              }),
              (y.prototype.focus = function() {
                this.isFrameClosed() || this._frame.focus();
              }),
              (y.prototype.createHandler = function(e) {
                return (
                  (e = e || {}),
                  {
                    close: function() {
                      e.beforeClose && e.beforeClose(), this.close();
                    }.bind(this),
                    focus: function() {
                      e.beforeFocus && e.beforeFocus(), this.focus();
                    }.bind(this)
                  }
                );
              }),
              (y.prototype.createNoopHandler = function() {
                return { close: e, focus: e };
              }),
              (y.prototype.teardown = function() {
                this.close(),
                  this._dispatchFrame.parentNode.removeChild(
                    this._dispatchFrame
                  ),
                  (this._dispatchFrame = null),
                  this._cleanupFrame();
              }),
              (y.prototype.isFrameClosed = function() {
                return null == this._frame || this._frame.isClosed();
              }),
              (y.prototype._cleanupFrame = function() {
                (this._frame = null),
                  clearInterval(this._popupInterval),
                  (this._popupInterval = null);
              }),
              (y.prototype._pollForPopupClose = function() {
                return (
                  (this._popupInterval = setInterval(
                    function() {
                      this.isFrameClosed() &&
                        (this._cleanupFrame(),
                        this._onCompleteCallback &&
                          this._onCompleteCallback(
                            new p(r.FRAME_SERVICE_FRAME_CLOSED)
                          ));
                    }.bind(this),
                    c.POPUP_POLL_INTERVAL
                  )),
                  this._popupInterval
                );
              }),
              (y.prototype._getFrameForEnvironment = function(e) {
                var t = f.supportsPopups(),
                  n = Boolean(o.popupBridge),
                  r = h({}, this._options, e);
                return n ? new s(r) : t ? new i(r) : new a(r);
              }),
              (E.exports = y);
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {
          "../../braintree-error": 29,
          "../../bus": 32,
          "../../is-https": 53,
          "../../vendor/uuid": 62,
          "../shared/browser-detection": 49,
          "../shared/constants": 50,
          "../shared/errors": 51,
          "../shared/events": 52,
          "./../../assign": 27,
          "./strategies/modal": 44,
          "./strategies/popup": 47,
          "./strategies/popup-bridge": 45,
          "@braintree/iframer": 14
        }
      ],
      43: [
        function(e, t, n) {
          "use strict";
          var r = e("./frame-service");
          t.exports = {
            create: function(e, t) {
              var n = new r(e);
              n.initialize(function() {
                t(n);
              });
            }
          };
        },
        { "./frame-service": 42 }
      ],
      44: [
        function(a, c, e) {
          (function(t) {
            "use strict";
            var n = a("@braintree/iframer"),
              r = a("../../../assign").assign,
              o = a("../../shared/browser-detection"),
              i = {
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                padding: 0,
                margin: 0,
                border: 0,
                outline: "none",
                zIndex: 20001,
                background: "#FFFFFF"
              };
            function e() {}
            function s(e) {
              (this._closed = null),
                (this._frame = null),
                (this._options = e || {}),
                (this._container = this._options.container || document.body);
            }
            (s.prototype.initialize = e),
              (s.prototype.open = function() {
                var e = {
                  src: this._options.openFrameUrl,
                  name: this._options.name,
                  scrolling: "yes",
                  height: "100%",
                  width: "100%",
                  style: r({}, i),
                  title: "Lightbox Frame"
                };
                o.isIos()
                  ? (o.isIosWKWebview() &&
                      (this._lockScrolling(), (e.style = {})),
                    (this._el = document.createElement("div")),
                    r(this._el.style, i, {
                      height: "100%",
                      width: "100%",
                      overflow: "auto",
                      "-webkit-overflow-scrolling": "touch"
                    }),
                    (this._frame = n(e)),
                    this._el.appendChild(this._frame))
                  : (this._el = this._frame = n(e)),
                  (this._closed = !1),
                  this._container.appendChild(this._el);
              }),
              (s.prototype.focus = e),
              (s.prototype.close = function() {
                this._container.removeChild(this._el),
                  (this._frame = null),
                  (this._closed = !0),
                  o.isIosWKWebview() && this._unlockScrolling();
              }),
              (s.prototype.isClosed = function() {
                return Boolean(this._closed);
              }),
              (s.prototype.redirect = function(e) {
                this._frame.src = e;
              }),
              (s.prototype._unlockScrolling = function() {
                (document.body.style.overflow = this._savedBodyProperties.overflowStyle),
                  (document.body.style.position = this._savedBodyProperties.positionStyle),
                  t.scrollTo(
                    this._savedBodyProperties.left,
                    this._savedBodyProperties.top
                  ),
                  delete this._savedBodyProperties;
              }),
              (s.prototype._lockScrolling = function() {
                var e = document.documentElement;
                (this._savedBodyProperties = {
                  left: (t.pageXOffset || e.scrollLeft) - (e.clientLeft || 0),
                  top: (t.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                  overflowStyle: document.body.style.overflow,
                  positionStyle: document.body.style.position
                }),
                  (document.body.style.overflow = "hidden"),
                  (document.body.style.position = "fixed"),
                  t.scrollTo(0, 0);
              }),
              (c.exports = s);
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {
          "../../../assign": 27,
          "../../shared/browser-detection": 49,
          "@braintree/iframer": 14
        }
      ],
      45: [
        function(r, o, e) {
          (function(n) {
            "use strict";
            var i = r("../../../braintree-error"),
              s = r("../../shared/errors");
            function e() {}
            function t(e) {
              (this._closed = null), (this._options = e);
            }
            (t.prototype.initialize = function(r) {
              var o = this;
              n.popupBridge.onComplete = function(e, t) {
                var n = !t && !e;
                (o._closed = !0),
                  e || n ? r(new i(s.FRAME_SERVICE_FRAME_CLOSED)) : r(null, t);
              };
            }),
              (t.prototype.open = function(e) {
                var t;
                (t = (e = e || {}).openFrameUrl || this._options.openFrameUrl),
                  (this._closed = !1),
                  n.popupBridge.open(t);
              }),
              (t.prototype.focus = e),
              (t.prototype.close = e),
              (t.prototype.isClosed = function() {
                return Boolean(this._closed);
              }),
              (t.prototype.redirect = function(e) {
                this.open({ openFrameUrl: e });
              }),
              (o.exports = t);
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "../../../braintree-error": 29, "../../shared/errors": 51 }
      ],
      46: [
        function(e, t, n) {
          "use strict";
          var i = e("../../../shared/constants"),
            r = e("./position");
          function s(e, t, n) {
            return void 0 !== t ? t : r[e](n);
          }
          t.exports = function(e) {
            var t = e.height || i.DEFAULT_POPUP_HEIGHT,
              n = e.width || i.DEFAULT_POPUP_WIDTH,
              r = s("top", e.top, t),
              o = s("left", e.left, n);
            return [
              i.POPUP_BASE_OPTIONS,
              "height=" + t,
              "width=" + n,
              "top=" + r,
              "left=" + o
            ].join(",");
          };
        },
        { "../../../shared/constants": 50, "./position": 48 }
      ],
      47: [
        function(r, o, e) {
          (function(e) {
            "use strict";
            var t = r("./compose-options");
            function n(e) {
              (this._frame = null), (this._options = e || {}), this.open();
            }
            (n.prototype.initialize = function() {}),
              (n.prototype.open = function() {
                this._frame = e.open(
                  this._options.openFrameUrl,
                  this._options.name,
                  t(this._options)
                );
              }),
              (n.prototype.focus = function() {
                this._frame.focus();
              }),
              (n.prototype.close = function() {
                this._frame.close();
              }),
              (n.prototype.isClosed = function() {
                return !this._frame || Boolean(this._frame.closed);
              }),
              (n.prototype.redirect = function(e) {
                this._frame.location.href = e;
              }),
              (o.exports = n);
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "./compose-options": 46 }
      ],
      48: [
        function(e, r, t) {
          (function(t) {
            "use strict";
            function n(e, t, n) {
              return (e - t) / 2 + n;
            }
            r.exports = {
              top: function(e) {
                return n(
                  t.outerHeight || document.documentElement.clientHeight,
                  e,
                  null == t.screenY ? t.screenTop : t.screenY
                );
              },
              left: function(e) {
                return n(
                  t.outerWidth || document.documentElement.clientWidth,
                  e,
                  null == t.screenX ? t.screenLeft : t.screenX
                );
              },
              center: n
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      49: [
        function(e, t, n) {
          "use strict";
          t.exports = {
            isIos: e("@braintree/browser-detection/is-ios"),
            isIosWKWebview: e("@braintree/browser-detection/is-ios-wkwebview"),
            isIE: e("@braintree/browser-detection/is-ie"),
            supportsPopups: e("@braintree/browser-detection/supports-popups")
          };
        },
        {
          "@braintree/browser-detection/is-ie": 6,
          "@braintree/browser-detection/is-ios": 11,
          "@braintree/browser-detection/is-ios-wkwebview": 10,
          "@braintree/browser-detection/supports-popups": 13
        }
      ],
      50: [
        function(e, t, n) {
          "use strict";
          t.exports = {
            DISPATCH_FRAME_NAME: "dispatch",
            DISPATCH_FRAME_CLASS: "braintree-dispatch-frame",
            POPUP_BASE_OPTIONS: "resizable,scrollbars",
            DEFAULT_POPUP_WIDTH: 450,
            DEFAULT_POPUP_HEIGHT: 535,
            POPUP_POLL_INTERVAL: 100,
            POPUP_CLOSE_TIMEOUT: 100
          };
        },
        {}
      ],
      51: [
        function(e, t, n) {
          "use strict";
          var r = e("../../braintree-error");
          t.exports = {
            FRAME_SERVICE_FRAME_CLOSED: {
              type: r.types.INTERNAL,
              code: "FRAME_SERVICE_FRAME_CLOSED",
              message: "Frame closed before tokenization could occur."
            },
            FRAME_SERVICE_FRAME_OPEN_FAILED: {
              type: r.types.INTERNAL,
              code: "FRAME_SERVICE_FRAME_OPEN_FAILED",
              message: "Frame failed to open."
            },
            FRAME_SERVICE_FRAME_OPEN_FAILED_IE_BUG: {
              type: r.types.INTERNAL,
              code: "FRAME_SERVICE_FRAME_OPEN_FAILED_IE_BUG",
              message:
                "Could not open frame. This may be due to a bug in IE browsers when attempting to open an HTTPS page from a HTTP page. https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11324352/"
            }
          };
        },
        { "../../braintree-error": 29 }
      ],
      52: [
        function(e, t, n) {
          "use strict";
          var r = e("../../enumerate");
          t.exports = r(
            ["DISPATCH_FRAME_READY", "DISPATCH_FRAME_REPORT"],
            "frameService:"
          );
        },
        { "../../enumerate": 40 }
      ],
      53: [
        function(e, n, t) {
          (function(t) {
            "use strict";
            n.exports = {
              isHTTPS: function(e) {
                return "https:" === (e = e || t.location.protocol);
              }
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      54: [
        function(e, t, n) {
          "use strict";
          var r,
            o = {
              "paypal.com": 1,
              "braintreepayments.com": 1,
              "braintreegateway.com": 1,
              "braintree-api.com": 1
            };
          t.exports = function(e) {
            var t;
            return (
              (e = e.toLowerCase()),
              !!/^https:/.test(e) &&
                (((r = r || document.createElement("a")).href = e),
                (t = (function(e) {
                  return e
                    .split(".")
                    .slice(-2)
                    .join(".");
                })(r.hostname)),
                o.hasOwnProperty(t))
            );
          };
        },
        {}
      ],
      55: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e) {
            return JSON.parse(JSON.stringify(e));
          };
        },
        {}
      ],
      56: [
        function(e, t, n) {
          "use strict";
          t.exports = function(t) {
            return Object.keys(t).filter(function(e) {
              return "function" == typeof t[e];
            });
          };
        },
        {}
      ],
      57: [
        function(e, t, n) {
          arguments[4][19][0].apply(n, arguments);
        },
        { dup: 19 }
      ],
      58: [
        function(n, r, e) {
          (function(e) {
            "use strict";
            var t = e.Promise || n("promise-polyfill");
            r.exports = t;
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        { "promise-polyfill": 23 }
      ],
      59: [
        function(e, n, t) {
          (function(t) {
            "use strict";
            function a(e, t) {
              var n,
                r,
                o,
                i,
                s = [];
              for (o in e)
                e.hasOwnProperty(o) &&
                  ((r = e[o]),
                  (n = t
                    ? (i = e) &&
                      "object" == typeof i &&
                      "number" == typeof i.length &&
                      "[object Array]" === Object.prototype.toString.call(i)
                      ? t + "[]"
                      : t + "[" + o + "]"
                    : o),
                  "object" == typeof r
                    ? s.push(a(r, n))
                    : s.push(
                        encodeURIComponent(n) + "=" + encodeURIComponent(r)
                      ));
              return s.join("&");
            }
            n.exports = {
              parse: function(e) {
                return (
                  (e = e || t.location.href),
                  /\?/.test(e)
                    ? e
                        .replace(/#.*$/, "")
                        .replace(/^.*\?/, "")
                        .split("&")
                        .reduce(function(e, t) {
                          var n = t.split("="),
                            r = decodeURIComponent(n[0]),
                            o = decodeURIComponent(n[1]);
                          return (e[r] = o), e;
                        }, {})
                    : {}
                );
              },
              stringify: a,
              queryify: function(e, t) {
                return (
                  (e = e || ""),
                  null != t &&
                    "object" == typeof t &&
                    (function(e) {
                      var t;
                      for (t in e) if (e.hasOwnProperty(t)) return !0;
                      return !1;
                    })(t) &&
                    ((e += -1 === e.indexOf("?") ? "?" : ""),
                    (e += -1 !== e.indexOf("=") ? "&" : ""),
                    (e += a(t))),
                  e
                );
              }
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      60: [
        function(e, t, n) {
          "use strict";
          t.exports = function(e) {
            return e ? "" : ".min";
          };
        },
        {}
      ],
      61: [
        function(e, r, t) {
          (function(t) {
            "use strict";
            var n = "function" == typeof t.atob ? t.atob : e;
            function e(e) {
              var t,
                n,
                r,
                o,
                i,
                s,
                a =
                  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                c = "";
              if (
                !new RegExp(
                  "^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$"
                ).test(e)
              )
                throw new Error(
                  "Non base64 encoded input passed to window.atob polyfill"
                );
              for (
                s = 0;
                (t =
                  ((63 & a.indexOf(e.charAt(s++))) << 2) |
                  (((o = a.indexOf(e.charAt(s++))) >> 4) & 3)),
                  (n =
                    ((15 & o) << 4) |
                    (((i = a.indexOf(e.charAt(s++))) >> 2) & 15)),
                  (r = ((3 & i) << 6) | (63 & a.indexOf(e.charAt(s++)))),
                  (c +=
                    String.fromCharCode(t) +
                    (n ? String.fromCharCode(n) : "") +
                    (r ? String.fromCharCode(r) : "")),
                  s < e.length;

              );
              return c;
            }
            r.exports = {
              atob: function(e) {
                return n.call(t, e);
              },
              _atob: e
            };
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {}
      ],
      62: [
        function(e, t, n) {
          "use strict";
          t.exports = function() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
              /[xy]/g,
              function(e) {
                var t = (16 * Math.random()) | 0;
                return ("x" === e ? t : (3 & t) | 8).toString(16);
              }
            );
          };
        },
        {}
      ],
      63: [
        function(E, g, e) {
          (function(c) {
            "use strict";
            var e = E("../../lib/frame-service/external"),
              u = E("../../lib/braintree-error"),
              i = E("../../lib/convert-to-braintree-error"),
              s = E("../../lib/use-min"),
              a = E("../../lib/once"),
              l = "3.47.0",
              p = E("../shared/constants"),
              t = E("../../lib/constants").INTEGRATION_TIMEOUT_MS,
              f = E("../../lib/analytics"),
              n = E("../../lib/methods"),
              d = E("../../lib/deferred"),
              h = E("../shared/errors"),
              r = E("../../lib/convert-methods-to-error"),
              _ = E("../../lib/querystring"),
              y = E("../../lib/promise"),
              o = E("@braintree/wrap-promise");
            function m(e) {
              (this._client = e.client),
                (this._assetsUrl =
                  e.client.getConfiguration().gatewayConfiguration.paypal
                    .assetsUrl +
                  "/web/" +
                  l),
                (this._isDebug = e.client.getConfiguration().isDebug),
                (this._loadingFrameUrl =
                  this._assetsUrl +
                  "/html/paypal-landing-frame" +
                  s(this._isDebug) +
                  ".html"),
                (this._authorizationInProgress = !1);
            }
            (m.prototype._initialize = function() {
              var n = this,
                r = this._client,
                o = setTimeout(function() {
                  f.sendEvent(r, "paypal.load.timed-out");
                }, t);
              return new y(function(t) {
                e.create(
                  {
                    name: p.LANDING_FRAME_NAME,
                    dispatchFrameUrl:
                      n._assetsUrl +
                      "/html/dispatch-frame" +
                      s(n._isDebug) +
                      ".html",
                    openFrameUrl: n._loadingFrameUrl
                  },
                  function(e) {
                    (n._frameService = e),
                      clearTimeout(o),
                      f.sendEvent(r, "paypal.load.succeeded"),
                      t(n);
                  }
                );
              });
            }),
              (m.prototype.tokenize = function(n, t) {
                var e,
                  r,
                  o = this,
                  i = this._client;
                return (
                  (t = t && a(d(t))),
                  n && p.FLOW_ENDPOINTS.hasOwnProperty(n.flow)
                    ? ((e = new y(function(e, t) {
                        o._authorizationInProgress
                          ? (f.sendEvent(
                              i,
                              "paypal.tokenization.error.already-opened"
                            ),
                            t(new u(h.PAYPAL_TOKENIZATION_REQUEST_ACTIVE)))
                          : ((o._authorizationInProgress = !0),
                            c.popupBridge ||
                              f.sendEvent(i, "paypal.tokenization.opened"),
                            !0 === n.offerCredit &&
                              f.sendEvent(i, "paypal.credit.offered"),
                            o._navigateFrameToAuth(n).catch(t),
                            o._frameService.open(
                              {},
                              o._createFrameServiceCallback(n, e, t)
                            ));
                      })),
                      t
                        ? (e
                            .then(function(e) {
                              t(null, e);
                            })
                            .catch(t),
                          this._frameService.createHandler({
                            beforeClose: function() {
                              f.sendEvent(
                                i,
                                "paypal.tokenization.closed.by-merchant"
                              );
                            }
                          }))
                        : e)
                    : ((r = new u(h.PAYPAL_FLOW_OPTION_REQUIRED)),
                      t
                        ? (t(r), this._frameService.createNoopHandler())
                        : y.reject(r))
                );
              }),
              (m.prototype._createFrameServiceCallback = function(r, o, i) {
                var s = this,
                  a = this._client;
                return c.popupBridge
                  ? function(e, t) {
                      var n =
                        t && t.path && "/cancel" === t.path.substring(0, 7);
                      (s._authorizationInProgress = !1),
                        e || n
                          ? (f.sendEvent(
                              a,
                              "paypal.tokenization.closed-popupbridge.by-user"
                            ),
                            i(new u(h.PAYPAL_POPUP_CLOSED)))
                          : t &&
                            s
                              ._tokenizePayPal(r, t.queryItems)
                              .then(o)
                              .catch(i);
                    }
                  : function(e, t) {
                      (s._authorizationInProgress = !1),
                        e
                          ? "FRAME_SERVICE_FRAME_CLOSED" === e.code
                            ? (f.sendEvent(
                                a,
                                "paypal.tokenization.closed.by-user"
                              ),
                              i(new u(h.PAYPAL_POPUP_CLOSED)))
                            : e.code &&
                              -1 <
                                e.code.indexOf(
                                  "FRAME_SERVICE_FRAME_OPEN_FAILED"
                                ) &&
                              i(
                                new u({
                                  code: h.PAYPAL_POPUP_OPEN_FAILED.code,
                                  type: h.PAYPAL_POPUP_OPEN_FAILED.type,
                                  message: h.PAYPAL_POPUP_OPEN_FAILED.message,
                                  details: { originalError: e }
                                })
                              )
                          : t &&
                            s
                              ._tokenizePayPal(r, t)
                              .then(o)
                              .catch(i);
                    };
              }),
              (m.prototype._tokenizePayPal = function(e, t) {
                var n = this,
                  r = this._client;
                return (
                  c.popupBridge ||
                    this._frameService.redirect(this._loadingFrameUrl),
                  r
                    .request({
                      endpoint: "payment_methods/paypal_accounts",
                      method: "post",
                      data: this._formatTokenizeData(e, t)
                    })
                    .then(function(e) {
                      var t = n._formatTokenizePayload(e);
                      return (
                        c.popupBridge
                          ? f.sendEvent(
                              r,
                              "paypal.tokenization.success-popupbridge"
                            )
                          : f.sendEvent(r, "paypal.tokenization.success"),
                        t.creditFinancingOffered &&
                          f.sendEvent(r, "paypal.credit.accepted"),
                        n._frameService.close(),
                        t
                      );
                    })
                    .catch(function(e) {
                      return (
                        c.popupBridge
                          ? f.sendEvent(
                              r,
                              "paypal.tokenization.failed-popupbridge"
                            )
                          : f.sendEvent(r, "paypal.tokenization.failed"),
                        n._frameService.close(),
                        y.reject(
                          i(e, {
                            type: h.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
                            code: h.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
                            message:
                              h.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message
                          })
                        )
                      );
                    })
                );
              }),
              (m.prototype._formatTokenizePayload = function(e) {
                var t,
                  n = {};
                return (
                  e.paypalAccounts && (n = e.paypalAccounts[0]),
                  (t = { nonce: n.nonce, details: {}, type: n.type }),
                  n.details &&
                    n.details.payerInfo &&
                    (t.details = n.details.payerInfo),
                  n.details &&
                    n.details.creditFinancingOffered &&
                    (t.creditFinancingOffered =
                      n.details.creditFinancingOffered),
                  t
                );
              }),
              (m.prototype._formatTokenizeData = function(e, t) {
                var n = this._client.getConfiguration(),
                  r = n.gatewayConfiguration,
                  o = "TOKENIZATION_KEY" === n.authorizationType,
                  i = {
                    paypalAccount: {
                      correlationId: t.ba_token || t.token,
                      options: { validate: "vault" === e.flow && !o }
                    }
                  };
                return (
                  t.ba_token
                    ? (i.paypalAccount.billingAgreementToken = t.ba_token)
                    : ((i.paypalAccount.paymentToken = t.paymentId),
                      (i.paypalAccount.payerId = t.PayerID),
                      (i.paypalAccount.unilateral = r.paypal.unvettedMerchant),
                      e.hasOwnProperty("intent") &&
                        (i.paypalAccount.intent = e.intent)),
                  i
                );
              }),
              (m.prototype._navigateFrameToAuth = function(n) {
                var r = this,
                  o = this._client,
                  e = "paypal_hermes/" + p.FLOW_ENDPOINTS[n.flow];
                return o
                  .request({
                    endpoint: e,
                    method: "post",
                    data: this._formatPaymentResourceData(n)
                  })
                  .then(function(e) {
                    var t;
                    (t =
                      "checkout" === n.flow
                        ? e.paymentResource.redirectUrl
                        : e.agreementSetup.approvalUrl),
                      "commit" === n.useraction &&
                        (t = _.queryify(t, { useraction: "commit" })),
                      c.popupBridge &&
                        f.sendEvent(
                          o,
                          "paypal.tokenization.opened-popupbridge"
                        ),
                      r._frameService.redirect(t);
                  })
                  .catch(function(e) {
                    var t = e.details && e.details.httpStatus;
                    return (
                      r._frameService.close(),
                      (r._authorizationInProgress = !1),
                      422 === t
                        ? y.reject(
                            new u({
                              type: h.PAYPAL_INVALID_PAYMENT_OPTION.type,
                              code: h.PAYPAL_INVALID_PAYMENT_OPTION.code,
                              message: h.PAYPAL_INVALID_PAYMENT_OPTION.message,
                              details: { originalError: e }
                            })
                          )
                        : y.reject(
                            i(e, {
                              type: h.PAYPAL_FLOW_FAILED.type,
                              code: h.PAYPAL_FLOW_FAILED.code,
                              message: h.PAYPAL_FLOW_FAILED.message
                            })
                          )
                    );
                  });
              }),
              (m.prototype._formatPaymentResourceData = function(e) {
                var t,
                  n = this._client.getConfiguration().gatewayConfiguration,
                  r = this._frameService._serviceId,
                  o = {
                    returnUrl:
                      n.paypal.assetsUrl +
                      "/web/" +
                      l +
                      "/html/paypal-redirect-frame" +
                      s(this._isDebug) +
                      ".html?channel=" +
                      r,
                    cancelUrl:
                      n.paypal.assetsUrl +
                      "/web/" +
                      l +
                      "/html/paypal-cancel-frame" +
                      s(this._isDebug) +
                      ".html?channel=" +
                      r,
                    offerPaypalCredit: !0 === e.offerCredit,
                    experienceProfile: {
                      brandName: e.displayName || n.paypal.displayName,
                      localeCode: e.locale,
                      noShipping: (!e.enableShippingAddress).toString(),
                      addressOverride: !1 === e.shippingAddressEditable,
                      landingPageType: e.landingPageType
                    }
                  };
                if (
                  (c.popupBridge &&
                    "function" == typeof c.popupBridge.getReturnUrlPrefix &&
                    ((o.returnUrl =
                      c.popupBridge.getReturnUrlPrefix() + "return"),
                    (o.cancelUrl =
                      c.popupBridge.getReturnUrlPrefix() + "cancel")),
                  "checkout" === e.flow)
                )
                  for (t in ((o.amount = e.amount),
                  (o.currencyIsoCode = e.currency),
                  e.hasOwnProperty("intent") && (o.intent = e.intent),
                  e.shippingAddressOverride))
                    e.shippingAddressOverride.hasOwnProperty(t) &&
                      (o[t] = e.shippingAddressOverride[t]);
                else
                  (o.shippingAddress = e.shippingAddressOverride),
                    e.billingAgreementDescription &&
                      (o.description = e.billingAgreementDescription);
                return o;
              }),
              (m.prototype.closeWindow = function() {
                this._authorizationInProgress &&
                  f.sendEvent(
                    this._client,
                    "paypal.tokenize.closed.by-merchant"
                  ),
                  this._frameService.close();
              }),
              (m.prototype.focusWindow = function() {
                this._frameService.focus();
              }),
              (m.prototype.teardown = o(function() {
                return (
                  this._frameService.teardown(),
                  r(this, n(m.prototype)),
                  f.sendEvent(this._client, "paypal.teardown-completed"),
                  y.resolve()
                );
              })),
              (g.exports = m);
          }.call(
            this,
            "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : {}
          ));
        },
        {
          "../../lib/analytics": 25,
          "../../lib/braintree-error": 29,
          "../../lib/constants": 33,
          "../../lib/convert-methods-to-error": 34,
          "../../lib/convert-to-braintree-error": 35,
          "../../lib/deferred": 39,
          "../../lib/frame-service/external": 43,
          "../../lib/methods": 56,
          "../../lib/once": 57,
          "../../lib/promise": 58,
          "../../lib/querystring": 59,
          "../../lib/use-min": 60,
          "../shared/constants": 65,
          "../shared/errors": 66,
          "@braintree/wrap-promise": 21
        }
      ],
      64: [
        function(e, t, n) {
          "use strict";
          var r = e("../lib/analytics"),
            o = e("../lib/basic-component-verification"),
            i = e("../lib/create-deferred-client"),
            s = e("../lib/create-assets-url"),
            a = e("../lib/braintree-error"),
            c = e("./shared/errors"),
            u = e("./external/paypal"),
            l = e("@braintree/wrap-promise"),
            p = e("../lib/promise");
          t.exports = {
            create: l(function(n) {
              return o
                .verify({
                  name: "PayPal",
                  client: n.client,
                  authorization: n.authorization
                })
                .then(function() {
                  return i.create({
                    authorization: n.authorization,
                    client: n.client,
                    debug: n.debug,
                    assetsUrl: s.create(n.authorization),
                    name: "PayPal"
                  });
                })
                .then(function(e) {
                  var t = e.getConfiguration();
                  return (
                    (n.client = e),
                    !0 !== t.gatewayConfiguration.paypalEnabled
                      ? p.reject(new a(c.PAYPAL_NOT_ENABLED))
                      : (r.sendEvent(n.client, "paypal.initialized"),
                        new u(n)._initialize())
                  );
                });
            }),
            isSupported: function() {
              return !0;
            },
            VERSION: "3.47.0"
          };
        },
        {
          "../lib/analytics": 25,
          "../lib/basic-component-verification": 28,
          "../lib/braintree-error": 29,
          "../lib/create-assets-url": 36,
          "../lib/create-deferred-client": 38,
          "../lib/promise": 58,
          "./external/paypal": 63,
          "./shared/errors": 66,
          "@braintree/wrap-promise": 21
        }
      ],
      65: [
        function(e, t, n) {
          "use strict";
          t.exports = {
            LANDING_FRAME_NAME: "braintreepaypallanding",
            FLOW_ENDPOINTS: {
              checkout: "create_payment_resource",
              vault: "setup_billing_agreement"
            }
          };
        },
        {}
      ],
      66: [
        function(e, t, n) {
          "use strict";
          var r = e("../../lib/braintree-error");
          t.exports = {
            PAYPAL_NOT_ENABLED: {
              type: r.types.MERCHANT,
              code: "PAYPAL_NOT_ENABLED",
              message: "PayPal is not enabled for this merchant."
            },
            PAYPAL_TOKENIZATION_REQUEST_ACTIVE: {
              type: r.types.MERCHANT,
              code: "PAYPAL_TOKENIZATION_REQUEST_ACTIVE",
              message: "Another tokenization request is active."
            },
            PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
              type: r.types.NETWORK,
              code: "PAYPAL_ACCOUNT_TOKENIZATION_FAILED",
              message: "Could not tokenize user's PayPal account."
            },
            PAYPAL_FLOW_FAILED: {
              type: r.types.NETWORK,
              code: "PAYPAL_FLOW_FAILED",
              message: "Could not initialize PayPal flow."
            },
            PAYPAL_FLOW_OPTION_REQUIRED: {
              type: r.types.MERCHANT,
              code: "PAYPAL_FLOW_OPTION_REQUIRED",
              message: "PayPal flow property is invalid or missing."
            },
            PAYPAL_POPUP_OPEN_FAILED: {
              type: r.types.MERCHANT,
              code: "PAYPAL_POPUP_OPEN_FAILED",
              message:
                "PayPal popup failed to open, make sure to tokenize in response to a user action."
            },
            PAYPAL_POPUP_CLOSED: {
              type: r.types.CUSTOMER,
              code: "PAYPAL_POPUP_CLOSED",
              message: "Customer closed PayPal popup before authorizing."
            },
            PAYPAL_INVALID_PAYMENT_OPTION: {
              type: r.types.MERCHANT,
              code: "PAYPAL_INVALID_PAYMENT_OPTION",
              message: "PayPal payment options are invalid."
            }
          };
        },
        { "../../lib/braintree-error": 29 }
      ]
    },
    {},
    [64]
  )(64);
});
